<template>
	<div class="pmybaogao-wrap">
		<div class="baoGaoList" v-show="isBaoGao">
			<div style="height: .4rem"></div>
				<div class="list-content">
					<div>
						<p>
							<b>检测人 : </b>
							<span>陆大鸟</span>
						</p>
						<p>
							<i>查看</i>
						</p>
					</div>
					<ul>
						<li>
							<b>检测结果 : </b>
							<span>良好</span>
						</li>
						<li>
							<b>检测时间 : </b>
							<span>2017-05-25</span>
						</li>
						<li>
							<b>检测套餐 : </b>
							<span>青年版-VIP套餐</span>
						</li>
					</ul>
				</div>
			<div style="height: .56rem"></div>
		</div>
		<div class="mybaogao-null" v-show="isNull">
			<img src="../assets/nullbaogao.png" />
			<h5>
				如果想查询报告，请先完善信息
			</h5>
			<p>
				<span>因涉及个人数据隐私</span>
				<span>查询数据前请务必注册信息或进行微信绑定</span>
			</p>
		</div>
		<myheader></myheader>
	</div>
</template>
<script>
	import myheader from '@/phonecomponents/pheader'
		const components = {
			myheader
		}
	
	export default {
		components:components,
		data() {
			return {
				isNull: false,
				isBaoGao: false
			}
		},
		created() {
			this.$http.post(urls.urltest + '/personal/getMyReport.json', {
				token: localStorage.getItem('token'),
			}).then(function(res) {
				console.log(res.body);
				if(res.body.records.length){
					this.isBaoGao = true
					this.isNull =  false
				}else{
					this.isBaoGao = false
					this.isNull =  true
				}
			});
		}
	}
</script>

<style lang="scss">
	 @import "../styles/core/reset.scss";
	.pmybaogao-wrap{
		width: 100%;
		height: 100%;
		position: relative;
		.mybaogao-null{
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%,-50%);
			
			img{
				height: 1.05rem;	
			}
			h5{
				font-size: .18rem;
				text-align: center;
				padding: .4rem 0 .1rem 0;
			}
			p{
				text-align: center;
				font-size: .16rem;
				span{
					display: block;
					color: #999;
				}
			}
		}
		.baoGaoList{
			.list-content{
				font-size: .16rem;
				width: 100%;
				background: #fff;
				margin-bottom: .1rem;
				border-bottom: 1px solid #E9E9E9;
				border-top: 1px solid #E9E9E9;
				box-sizing: border-box;
				div{
					@include flexbox;
					width: 100%;
					height: .5rem;
					border-bottom: 1px dotted #979797;
					align-items: center;
					p{
						@include flex;
						width: 100%;
						span{
							color: #616060;
						}
						&:first-child{
							padding-left: .15rem;
						}
						&:last-child{
							text-align: right;
							i{
								display: inline-block;
								width: 1.2rem;
								height: .32rem;
								background: #01BCD4;
								color: #fff;
								line-height: .32rem;
								text-align: center;
								margin-right: .15rem;
								box-shadow: 0 0px 3px 1px #c0d0d2;
							}
						}
					}
				}
				ul{
					li{
						padding: .15rem 0 0 .15rem;
						span{
							color: #616060;
						}
						&:last-child{
							padding-bottom: .15rem;
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// mybaogao.vue?070a735c